<template>
<div class="chapter">
<div class="inner_page">
<section class="chap" epub:type="chapter" id="chap-001"><span epub:type="pagebreak" id="page_9" title="9">
<div class="chap_debut"></div>
<h1 class="chap_n" epub:type="title"><span>1</span></h1>
<h1 class="chap_tit" epub:type="title"><span>Strangers<br/>in the World</span></h1>
<h1 class="chap_stit" epub:type="subtitle"><span><span class="mev3">1 Peter 1:1-12</span></span></h1>
<div class="dev">
<p class="txt_courant_ssalinea">All of us have experienced times when we did not fit in: arriving overdressed (or underdressed) for a social occasion, not knowing the language spoken around us, being in a setting as a minority race or gender, holding a single dissenting opinion in a hotly debated topic. But underneath these embarrassing and painful moments sometimes lurks a pervasive sense that maybe we don’t fit anywhere—really.</p>
<p class="bl"> </p>
<p class="txt_courant_ssalinea">G<span class="small">ROUP</span> D<span class="small">ISCUSSION</span>. Tell of a time when you felt out of place—like a stranger who did not belong.</p>
<p class="bl"> </p>
<p class="txt_courant_ssalinea">P<span class="small">ERSONAL</span> R<span class="small">EFLECTION</span>. If you knew you were about to enter a difficult set of circumstances that would test your faith, how would you prepare yourself?</p>
<form action="traitement.php" method="post" name="response">
<p>
<label></label>
<br/>
<textarea name="response"></textarea>
</p>
</form>
<p class="bl"> </p>
<p class="txt_courant_ssalinea">Early Christians were subject to many kinds of isolation. Though their faith originated in Judaism, the Jews rejected them because Christians saw Jesus as Messiah. Romans would eventually use Christians as scapegoats, blaming them for all sorts of political woes. And <span epub:type="pagebreak" id="page_10" title="10">pagans saw Christians as atheists because they insisted on worshiping only one God. In this setting, Peter offers beleaguered first-century Christians (and us) a different kind of belonging. <i>Read 1 Peter 1:1-12.</i></span></p>
<p class="bl"> </p>
<div class="lettre">
<p class="txt_courant_ssalinea"><b>1. </b>Imagine you are one of the early Christians receiving Peter’s letter. After studying this opening section, what would motivate you to keep reading?</p>
</div>
<form action="traitement.php" method="post" name="response">
<p>
<label></label>
<br/>
<textarea name="response"></textarea>
</p>
</form>
<div class="lettre">
<p class="txt_courant_ssalinea"><b>2. </b>Study Peter’s description of the people who were about to receive his letter (vv. 1-2). How does his description of them help explain why they were “strangers in the world”?</p>
</div>
<form action="traitement.php" method="post" name="response">
<p>
<label></label>
<br/>
<textarea name="response"></textarea>
</p>
</form>
<div class="lettre">
<p class="txt_courant_ssalinea"><b>3. </b>How does the introduction to Peter’s letter help you appreciate the three persons of God?</p>
</div>
<form action="traitement.php" method="post" name="response">
<p>
<label></label>
<br/>
<textarea name="response"></textarea>
</p>
</form>
<div class="lettre">
<p class="txt_courant_ssalinea"><b>4. </b>Peter says that God has given his people “new birth.” What does he say grows out of that new birth (vv. 3-5)?</p>
</div>
<form action="traitement.php" method="post" name="response">
<p>
<label></label>
<br/>
<textarea name="response"></textarea>
</p>
</form>
<div class="lettre">
<p class="txt_courant_ssalinea"><b><span epub:type="pagebreak" id="page_11" title="11">5. </span></b>Peter says in verse 6, “Now for a little while you may have had to suffer grief in all kinds of trials.” If you were to hear that kind of message, what information in this paragraph might help you through the suffering (vv. 3-9)?</p>
</div>
<form action="traitement.php" method="post" name="response">
<p>
<label></label>
<br/>
<textarea name="response"></textarea>
</p>
</form>
<div class="lettre">
<p class="txt_courant_ssalinea"><b>6. </b>How does the future as Peter describes it here offer you hope in your own setting?</p>
</div>
<form action="traitement.php" method="post" name="response">
<p>
<label></label>
<br/>
<textarea name="response"></textarea>
</p>
</form>
<div class="lettre">
<p class="txt_courant_ssalinea"><b>7. </b>What did Peter believe to be true of genuine faith (vv. 7-9)?</p>
</div>
<form action="traitement.php" method="post" name="response">
<p>
<label></label>
<br/>
<textarea name="response"></textarea>
</p>
</form>
<div class="lettre">
<p class="txt_courant_ssalinea"><b>8. </b>Peter complimented his readers because they believed in Jesus and loved him—even though they had not seen him (v. 8). What questions do you think people today have to cope with because they have not personally seen Jesus?</p>
</div>
<form action="traitement.php" method="post" name="response">
<p>
<label></label>
<br/>
<textarea name="response"></textarea>
</p>
</form>
<div class="lettre">
<p class="txt_courant_ssalinea"><b><span epub:type="pagebreak" id="page_12" title="12">9. </span></b>When have you seen Jesus (through a person or event) in a way that increased your faith?</p>
</div>
<form action="traitement.php" method="post" name="response">
<p>
<label></label>
<br/>
<textarea name="response"></textarea>
</p>
</form>
<div class="lettre">
<p class="txt_courant_ssalinea"><b>10. </b>By what different routes did news of salvation come to the readers of Peter’s letter (vv. 10-12)?</p>
</div>
<form action="traitement.php" method="post" name="response">
<p>
<label></label>
<br/>
<textarea name="response"></textarea>
</p>
</form>
<div class="lettre">
<p class="txt_courant_ssalinea"><b>11. </b>In what ways are Christians special—even when compared to Old Testament prophets and angels?</p>
</div>
<form action="traitement.php" method="post" name="response">
<p>
<label></label>
<br/>
<textarea name="response"></textarea>
</p>
</form>
<div class="lettre">
<p class="txt_courant_ssalinea"><b>12. </b>Peter refers to new birth, or salvation, throughout this passage as a central difference between Christians and the world. What tensions have you experienced because of this difference?</p>
</div>
<form action="traitement.php" method="post" name="response">
<p>
<label></label>
<br/>
<textarea name="response"></textarea>
</p>
</form>
<div class="lettre">
<p class="txt_courant_ssalinea"><b><span epub:type="pagebreak" id="page_13" title="13">13. </span></b>How does God’s gift of salvation help you cope with these tensions?</p>
</div>
<form action="traitement.php" method="post" name="response">
<p>
<label></label>
<br/>
<textarea name="response"></textarea>
</p>
</form>
<div class="encsansfilet" id="encp13">
<div class="dev">
<p class="txt_courant_ssalinea"><i>Pray thanking God that you belong to him and that you have an eternal home with him and his people. If you have not yet come into God’s family, ask (if you are able) that he continue to show you the way.</i></p>
</div>
</div>
<div class="niv2" id="niv2-001">
<h2 class="int_niv2" epub:type="title"><span>Now or Later</span></h2>
<p class="txt_courant_ssalinea">Review some of the people who came to mind as you considered question 9—people who have increased your faith. Write a letter of appreciation to one of them. If this is not possible, write a prayer of thanks to God for that person’s influence in your life.</p>
<p class="txt_courant_justif">Suffering and joy are mixed in this section of Peter’s letter—as they often are in our own lives. Consider the people and events that have brought you pain; consider also sources that have brought you joy. (Odd that they are sometimes the same sources.) In prayer, share all of this with your loving God, who understands the mixture far better than we do.</p>
<p class="txt_courant_justif">Read again 1 Peter 1:8-9. Meditate on love and joy as Peter describes them. Thank God for offering a joy that cannot be diminished by earthbound events. Then, as much as you are able, enjoy!</p>
<form action="traitement.php" method="post" name="response">
<p>
<label></label>
<br/>
<textarea name="response"></textarea>
</p>
</form>
</div>
</div>
</span></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap1.vue?1fa1576a